













































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex';
import Project from '@/models/Project.ts'
import UserGroup from '../../../models/UserGroup';
import SubscriptionPanel from '@/components/payment/SubscriptionPanel.vue'
import PaymentMethodManager from '@/components/payment/PaymentMethodManager.vue'
import ProjectUsers from '@/components/ProjectUsers.vue';

@Component(
{
	components: {
		SubscriptionPanel,
		PaymentMethodManager,
		ProjectUsers
	},
	computed: 
	{
		...mapGetters([
			'checkInviteManage',
			'checkAdmin',
			'checkUserManage',
			'checkUserGroupEdit'
		])
	}
})
export default class InviteModal extends Vue
{
	@Prop(Project) readonly project! : Project;

	role : number | null = null;
	roles : any[] | null = null;
	rolesMap : Map<number, any> | null = null;
	invites = null;
	creating = false;
	failureAlert : string | null = null;
	tier: Number | null = null;
	users : {premium: boolean}[] | null = null;
    freeUserBudget = 0;
	
	mounted()
	{
		this.refresh();
		this.getTier();
		this.loadUserData();
	}

	async getTier()
	{
		this.tier = await this.$store.dispatch('getProjectSubscription', this.project.pid);
	}

	refresh()
	{
		this.$set(this, "failureAlert", null);
		this.$set(this, "invites", null);
		this.$http.get(`invites/${this.project.id}`).then(
			async (res) =>
			{
				let invites : any[] = res.data.invites;
				invites = invites.sort(
					(a, b) =>
					{
						if (a.access_role == null || b.access_role == null)
							return 0;
						if (a.access_role < b.access_role)
							return -1;
						if (a.access_role > b.access_role)
							return 1;
						return 0;
					}
				);
				this.$set(this, "invites", invites);
			},
			(err) =>
			{
				console.error(`Error: ${err.response.data}`);
			}
		);
		this.loadUserGroups();
	}

	loadUserGroups()
	{
		this.$set(this, "roles", null);
		this.$set(this, "rolesMap", null);

		this.$http.get(`getprojectusergroups?pid=${this.project.id}`).then(
			(resp) =>
			{
				let filteredRoles = (resp.data.groups as Array<UserGroup>).filter((a) => (this as any).checkInviteManage(this.project.group, a));
				this.$set(this, "roles", filteredRoles);

				if (this.roles == null)
				{
					console.error(`Failed to load usergroups for project ${this.project.name}`);
					console.log(resp.data);
				}
				else
				{
					let ugo = new Map<number, any>();
					for (var i = 0; i < this.roles.length; ++i)
					{
						let index = <number>(this.roles[i]).id;
						ugo.set(index, this.roles[i]);
					}

					this.$set(this, "rolesMap", ugo);
				}
			},
			(error) =>
			{
				console.error(error.response);
			}
		);
	}

	roleName(id : number)
	{
		if (this.rolesMap == null || !(this.rolesMap.has(id)))
		{
			return '';
		}
		return (this.rolesMap.get(id) as any).name;
	}

	createInvite()
	{
		if (this.role == null || isNaN(this.role))
		{
			this.failureAlert = 'Please select a role';
		}
		else
		{
			this.creating = true;
			this.$http.post(`createinvite?pid=${this.project.id}&groupID=${this.role}`).then(
				(res) =>
				{
					this.creating = false;
					this.refresh();
				},
				(err) =>
				{
					this.creating = false;
					this.failureAlert = 'Failed to create project invite';
				}
			);
		}
	}

	copyField(field : HTMLInputElement)
	{
		console.log(field);
		field.select();
		document.execCommand('copy');
	}

	loadUserData()
	{
		this.$set(this, "users", null);            
		this.$http.get("viewprojectusers?pid=" + this.project.pid)
			.then(
				(resp)=>
				{
					this.$set(this, "users", resp.data.users);
				},
				(error)=>
				{
					console.error(error.response);
				});
		this.loadFreeUserBudget();
	}

	loadFreeUserBudget()
	{            
		this.$http.get("projects/freeuserbudget?projectid=" + this.project.pid)
			.then(
				(resp) =>
				{
					this.$set(this, "freeUserBudget", resp.data.budget);
				},
				(error) =>
				{
					console.error(error.response);
				});
	}

	get freeUserCount()
	{
		let count = 0;
		if (this.users != null)
		{
			for (let i = 0; i < this.users.length; ++i)
			{
				if (!(this.users[i].premium))
				{
					++count;
				}
			}
		}
		return count;
	}
}
